import React from 'react';
import { Col, Divider, Row } from 'antd';
import { PrintDateShort } from '../../utils/timeParser';
import { getFormatCurrency } from '../../utils/commonUtils';
import Wrapper from './style';
import { INTEGRATOR_TWITTER } from '../../configs/integrator';

const { PACING_OPTION } = INTEGRATOR_TWITTER();

const onGetDate = (date) => {
  if (!date) return false;
  return PrintDateShort(date);
};

const Description = (props) => {
  const { label, value, emptyText = '(empty)', onParseValue } = props;

  const displayValue = () => {
    if (onParseValue && value) {
      const text = value.replace(/_/g, ' ');
      const parse = text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
      return parse;
    }
    return value;
  };

  return (
    <Row gutter={[4, 4]}>
      {label && (
        <Col
          span={24}
          className="font-paragraph_medium black3 description_label"
        >
          {label}
        </Col>
      )}
      <Col
        span={24}
        className={`font-paragraph ${
          value ? 'black1' : 'black4'
        } description_value`}
      >
        {displayValue() || emptyText}
      </Col>
    </Row>
  );
};

const Campaign = (props) => {
  const { dataSource } = props;
  const biddingRules = dataSource?.helper?.bidding_rules || {};
  const fundingInstrument = dataSource?.helper?.funding_instrument || {};
  const campaignData = dataSource?.data?.twitter_campaign || {};
  const objective = dataSource?.data?.twitter_line_item?.objective;
  const startDate = onGetDate(campaignData?.start_time);
  const endDate = onGetDate(campaignData?.end_time);

  // const onGetObjective = CAMPAIGN_OBJECTIVE_OPTION.find((item) => {
  //   return item?.options?.some((val) => {
  //     return val.value === objective;
  //   });
  // })?.options.find((item) => {
  //   return item?.value === objective;
  // });

  const onGetPacing = PACING_OPTION.find((item) => {
    return item?.value === campaignData?.standard_delivery;
  });

  return (
    <Wrapper>
      <Row gutter={[24, 24]}>
        <Col span={24}>
          <Description label="Campaign Name" value={campaignData?.name} />
        </Col>
        <Col span={24}>
          <Description
            label="Campaign Objective"
            value={objective}
            onParseValue="true"
          />
        </Col>
        <Col span={24}>
          <Divider style={{ margin: 0 }} />
        </Col>
        <Col span={24}>
          <Description
            label="Funding source"
            onParseValue="true"
            value={fundingInstrument?.description}
          />
        </Col>
        <Col span={24}>
          <Row gutter={16}>
            <Col span={12}>
              <Description label="Start Date" value={startDate} />
            </Col>
            <Col span={12}>
              <Description label="End Date" value={endDate} />
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row gutter={16}>
            <Col span={12}>
              <Description
                label="Daily Budget"
                value={getFormatCurrency({
                  currency: biddingRules?.currency,
                  value:
                    campaignData?.daily_budget_amount_local_micro /
                    biddingRules?.minimum_denomination,
                })}
              />
            </Col>
            <Col span={12}>
              <Description
                label="Total Budget"
                value={getFormatCurrency({
                  currency: biddingRules?.currency,
                  value:
                    campaignData?.total_budget_amount_local_micro /
                    biddingRules?.minimum_denomination,
                })}
              />
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Divider style={{ margin: 0 }} />
        </Col>
        <Col span={24}>
          <Row gutter={[24, 24]}>
            <Col span={24} className="font-subtitle2_medium black1">
              Pacing
            </Col>
            <Col span={24}>
              <Description
                label={onGetPacing?.label}
                value={onGetPacing?.description}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </Wrapper>
  );
};

export default Campaign;
